import JobsReducer from "./reducer";

export const setJobList = (payload) => (dispatch) => {
  dispatch(JobsReducer.actions.setJobList(payload));
};

export const setJobCategoryList = (payload) => (dispatch) => {
  dispatch(JobsReducer.actions.setJobCategoryList(payload));
};

export const setGazetteList = (payload) => (dispatch) => {
  dispatch(JobsReducer.actions.setGazetteList(payload));
};

export const setJobCategory = (payload) => (dispatch) => {
  dispatch(JobsReducer.actions.setJobCategory(payload));
};
export const setJobs = (payload) => (dispatch) => {
  dispatch(JobsReducer.actions.setJobs(payload));
};

export const setGazette = (payload) => (dispatch) => {
  dispatch(JobsReducer.actions.setGazette(payload));
};

export const updateJobCategory = (payload) => (dispatch) => {
  dispatch(JobsReducer.actions.updateJobCategory(payload));
};

export const clearedSelectJobs = () => (dispatch) => {
  dispatch(JobsReducer.actions.clearedSelectJobs());
};
